import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon-types';

export type PlayIconProps = IconProps;

export const PlayIcon: FC<PlayIconProps> = ({ iconColor = '#ffffff', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    {...props}
    fill="none"
    height="13"
    viewBox="0 0 11 13"
    width="11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.983398 2.07618C0.983398 1.42874 0.983398 1.10502 1.11839 0.926567C1.23599 0.771108 1.41575 0.674908 1.61033 0.66329C1.83369 0.649953 2.10304 0.829522 2.64175 1.18866L9.65212 5.86224C10.0972 6.15899 10.3198 6.30737 10.3974 6.49438C10.4652 6.65788 10.4652 6.84164 10.3974 7.00514C10.3198 7.19216 10.0972 7.34053 9.65212 7.63728L2.64174 12.3109C2.10304 12.67 1.83369 12.8496 1.61033 12.8362C1.41575 12.8246 1.23599 12.7284 1.11839 12.573C0.983398 12.3945 0.983398 12.0708 0.983398 11.4233V2.07618Z"
      fill={iconColor}
    />
  </svg>
);
